import React from "react";
import logo from "./logo.svg";
import leftImage from "./images/challenges-left-image.png";
import Layout, { TAB_LOOKUP } from "./Layout";
import ArrowButton from "./ArrowButton";
import image from "./images/capabilities1-image.png";
import { t } from "i18next";

function Capabilities1Screen() {
  return (
    <div className="fill-absolute">
      <div className="container full-height row">
        <img
          src={image}
          alt="two people working at a desk"
          className="show-mobile"
          style={{ width: "100%", marginTop: 40, marginBottom: 20 }}
        />
        <div
          className="full-height flex fit-background-image hide-mobile"
          style={{
            backgroundImage: `url(${image})`,
            height: "80%",
            alignSelf: "center",
          }}
        ></div>
        <div className="full-height padding flex vertical-center">
          <h2 className="blue-header">{t("Capability1.title")}</h2>
          <p>{t("Capability1.section1")}</p>
        </div>
      </div>
      <div className="buttons-container">
        <ArrowButton to="/capabilities" side="left"></ArrowButton>
        <ArrowButton to="/capabilities-biometrics" side="right"></ArrowButton>
      </div>
    </div>
  );
}

export default Capabilities1Screen;
